import React from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { AccountInfoLabel } from '@woovi/ui';
import { convertToMoney } from '@woovi/utils';

import type { PaymentLinkDeletedValue_charge$key } from './__generated__/PaymentLinkDeletedValue_charge.graphql.ts';
import type { PaymentLinkDeletedValue_pixQrCode$key } from './__generated__/PaymentLinkDeletedValue_pixQrCode.graphql.ts';

import type { ReactNode } from 'react';

type PaymentLinkDeletedValueProps = {
  charge: PaymentLinkDeletedValue_charge$key;
  pixQrCode: PaymentLinkDeletedValue_pixQrCode$key;
};

const PaymentLinkDeletedValue = (
  props: PaymentLinkDeletedValueProps,
): ReactNode => {
  const { t } = useTranslation();

  const charge = useFragment<PaymentLinkDeletedValue_charge$key>(
    graphql`
      fragment PaymentLinkDeletedValue_charge on Charge {
        id
        value
        valueWithDiscount
      }
    `,
    props.charge,
  );

  const pixQrCode = useFragment<PaymentLinkDeletedValue_pixQrCode$key>(
    graphql`
      fragment PaymentLinkDeletedValue_pixQrCode on PixQrCode {
        id
        value
      }
    `,
    props.pixQrCode,
  );

  const getValue = () => {
    if (pixQrCode) {
      if (!pixQrCode.value) {
        return t('Defined by customer');
      }

      return convertToMoney(pixQrCode.value);
    }

    if (charge.valueWithDiscount) {
      return convertToMoney(charge.valueWithDiscount);
    }

    return convertToMoney(charge.value);
  };

  return <AccountInfoLabel label={t('Value')} text={getValue()} />;
};

export default PaymentLinkDeletedValue;
